
import { defineComponent, onMounted } from 'vue'
import vConsole from 'vconsole'
import env from '@/core/utils/env'
export default defineComponent({
  name: 'LayoutDownload',
  setup() {
    onMounted(() => {
      // eslint-disable-next-line new-cap
      if (env === 'testing' || env === 'pre') {
        // eslint-disable-next-line new-cap
        new vConsole()
      }
      const { documentElement } = document
      console.log(
        `current page width: ${documentElement.clientWidth}, current page height: ${documentElement.clientHeight}, dpr=${window.devicePixelRatio}`
      )
    })
  }
})
